import ApiServices from '@/services/uteis/ApiServices.js';
import route from '@/libs/endPoint/ava/EstagiariosMagisterioRoutes';

class EstagiariosMagisterioServices {
  async load(params) {
    try {
      const url = route.main;
      const { data } = await ApiServices.get(url, params);
      return data;
    } catch (error) {
      console.error('Erro ao buscar dados da inscrição:', error);
      throw error;
    }
  }
  async insert(params) {
    try {
      const url = route.main;
      const { data } = await ApiServices.post(url, params);
      return data;
    } catch (error) {
      console.error('Erro ao buscar dados da inscrição:', error);
      throw error;
    }
  }
  async remove(fkpessoa) {
    try {
      const url = route.remove(fkpessoa);
      const { data } = await ApiServices.delete(url);
      return data;
    } catch (error) {
      console.error('Erro ao buscar dados da inscrição:', error);
      throw error;
    }
  }
}
export default new EstagiariosMagisterioServices();
